import React from "react";
import { Skeleton } from "antd";

import "../../tokens/tokens.css";
import "./index.css";

const TONE_CLASSNAMES = {
  default: "",
  green: "v2-card-tone-green",
  red: "v2-card-tone-red",
  blue: "v2-card-tone-blue",
  muted: "v2-card-tone-muted",
};

/**
 * V2Card — Rapsap Operations "metric" card: a big value + a label underneath.
 *
 * Plain <div>, not antd's Card: src/screens/Dashboard/index.css sets a bare,
 * unscoped `.ant-card { border-radius: 12px }` — CRA bundles every screen's
 * CSS globally regardless of route, so that rule is live on every page and
 * would fight our own radius depending on module/build order (the same
 * class of bug that broke V2Badge via antd's Tag). Nothing about Card's own
 * behavior (loading spinner, hoverable) is used here, so a plain element
 * sidesteps it entirely.
 *
 * `loading` swaps the value for a skeleton; the label stays, since it's known.
 */
export default function V2Card({ value, label, tone = "default", className = "", loading = false }) {
  const toneClass = TONE_CLASSNAMES[tone] || "";
  return (
    <div className={`v2-card ${toneClass} ${className}`.trim()} aria-busy={loading || undefined}>
      {loading ? (
        <Skeleton.Button active size="large" className="v2-card-value-skeleton" />
      ) : (
        <p className="v2-card-value">{value}</p>
      )}
      <p className="v2-card-label">{label}</p>
    </div>
  );
}
